import { THRIVEWORKS_HOME } from 'constants/footer'
import { enhanceUrlWithMarketingParams } from 'lib/marketingParams'
import BrandLogo from './index'

type BrandLogoLinkProps = {
  width: number
  height: number
  className?: string
  src?: string
  alt?: string
  href?: string
  linkClassName?: string
}

/**
 * Brand logo wrapped in an anchor that appends persisted marketing params to the
 * target URL (relative paths and thriveworks.com domains).
 */
const BrandLogoLink: React.FC<BrandLogoLinkProps> = ({
  href = THRIVEWORKS_HOME,
  linkClassName = '',
  ...logoProps
}) => {
  return (
    <a href={enhanceUrlWithMarketingParams(href)} className={linkClassName}>
      <BrandLogo {...logoProps} />
    </a>
  )
}

export default BrandLogoLink
